import { z } from "zod";
import { nonEmptyString } from "./nonEmptyString.js";

export const urlSchema = nonEmptyString.superRefine((data, ctx) => {
	if (!data.startsWith("/") && !URL.canParse(data)) {
		ctx.addIssue({
			code: z.ZodIssueCode.invalid_string,
			validation: "url",
		});
	}
});
